<script>
    import { createEventDispatcher } from 'svelte';

    // Declare the dispatcher
    const dispatch = createEventDispatcher();

    //PROPS
    export let label = '';
    export let consentError = false;

    //METHODS
    const changeConsent = (event) => {
        dispatch('brandConsent', event.target.checked);
    };
</script>

<!-- ======================== HTML TEMPLATE ================================= -->
<div class="app-msi_form-check">
    <fieldset class={consentError ? 'emi-has-error' : 'app-msi_no-border'}>
        <input
            class="app-msi_form-check-input"
            type="checkbox"
            on:click={(event) => changeConsent(event)}
            id="brandConsent"
            required="true"
        />
        <label class="app-msi_form-check-label" for="brandConsent">
            {label}
        </label>
    </fieldset>
</div>
